import blog1 from '../../images/blogs/good-vs-bad-fear.jpg';

export default 'Blog Data';

export const blogs = [
  {
    id: 0, badge: 'Professional', title: 'Good vs Bad Fear', desc: 'I published an article regarding Fear and its traits. How you can use fear for you own benefit.', img: blog1, link: 'https://medium.com/@hammassaleem/good-fear-vs-bad-fear-4e3d86d1a4dc',
  },
];
